import { buildBaseSchema } from './schema'

/** Ready solo-practice (مطب شخصی) site schema. */
export const soloTemplate = buildBaseSchema('solo')
